import { render } from "./ProductQuote.vue?vue&type=template&id=04f31b50&scoped=true"
import script from "./ProductQuote.vue?vue&type=script&lang=js"
export * from "./ProductQuote.vue?vue&type=script&lang=js"

import "./ProductQuote.vue?vue&type=style&index=0&id=04f31b50&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f31b50"]])

export default __exports__